import axios from "axios";
import { toast } from "react-toastify";
import { Vocabulary } from "./Vocabulary";
import { urlEnum } from "./urlEnum";
import { disableTostifyConfig } from "./utils";
import { ApiErrorBody } from "./apiEnvelope";

function shouldNotifyPostSuccess(url?: string): boolean {
  return (
    !!url &&
    url !== "/api/logout" &&
    url !== "/api/login" &&
    !url.includes("api/vehicule/vehiclesEditing") &&
    !url.includes("api/notifications") &&
    !url.includes("/api/templates/generateGDPR") &&
    !url.includes("/api/vehicule/search") &&
    !url.includes("/api/transports") &&
    url !== urlEnum.getCountries &&
    !url.includes(urlEnum.userBonuses) &&
    !url.includes(disableTostifyConfig)
  );
}

function shouldNotifyPutSuccess(url?: string): boolean {
  return !url?.includes(urlEnum.notes) && !url?.includes(disableTostifyConfig);
}

function shouldNotifyDeleteSuccess(url?: string): boolean {
  return !!url && !url.includes("api/vehicule/vehiclesEditing");
}

export function notifySuccessForResponse(response: any): void {
  if (response?.status !== 200 && response?.status !== 201) {
    return;
  }
  const { method, url } = response.config;
  if (method === "post" && shouldNotifyPostSuccess(url)) {
    toast.success(Vocabulary.successfullyAdded);
  }
  if (method === "put" && shouldNotifyPutSuccess(url)) {
    toast.success(Vocabulary.successfullyUpdated);
  }
  if (method === "delete" && shouldNotifyDeleteSuccess(url)) {
    toast.success(Vocabulary.successfullyDeleted);
  }
}

function notifyErrorMessageOrFallback(message: string | undefined, error: any): void {
  if (message && !error?.config?.url?.includes(disableTostifyConfig)) {
    toast.error(message);
    return;
  }
  if (error.config.method === "post" && !error?.config?.url?.includes(disableTostifyConfig)) {
    toast.error(Vocabulary.addError);
  }
  if (error.config.method === "put") {
    toast.error(Vocabulary.updateError);
  }
  if (error.config.method === "delete") {
    toast.error(Vocabulary.deleteError);
  }
}

export function notifyErrorForResponse(error: any): void {
  if (error.code === axios.AxiosError.ECONNABORTED) {
    toast.error(Vocabulary.requestTimeoutError);
    return;
  }

  const data = error.response?.data;

  // Requests made with responseType: "blob" (file downloads) get their error body
  // wrapped as a Blob too, even when the server actually sent a JSON error - a real
  // file download's blob has a binary MIME type, so "application/json" here means
  // this is really a JSON error body that needs unwrapping before it can be read.
  if (data instanceof Blob && data.type.includes("application/json")) {
    data
      .text()
      .then((text: string) => JSON.parse(text) as ApiErrorBody)
      .then((parsed) => notifyErrorMessageOrFallback(parsed?.message, error))
      .catch(() => notifyErrorMessageOrFallback(undefined, error));
    return;
  }

  notifyErrorMessageOrFallback((data as ApiErrorBody | undefined)?.message, error);
}
